import { useCallback } from 'react';
import { useNavigate, useSearchParams, NavigateOptions } from 'react-router-dom';

/**
 * Custom navigate hook that preserves workspace context (?ws=xxx)
 *
 * Use this instead of useNavigate() to ensure workspace param is retained
 * across navigation within the app.
 */
export function useAppNavigate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useCallback(
    (to: string, options?: NavigateOptions) => {
      const ws = searchParams.get('ws');

      if (!ws) {
        // No workspace param, navigate normally
        navigate(to, options);
        return;
      }

      // Preserve workspace param
      const hasQuery = to.includes('?');
      const separator = hasQuery ? '&' : '?';
      const url = `${to}${separator}ws=${ws}`;

      navigate(url, options);
    },
    [navigate, searchParams]
  );
}
